import saveAs from 'file-saver';

import { PayloadRequest } from 'types/requestTypes';

import { omdApi } from '../../api';
import {
  CashFlowAccounts,
  CashFlowDocumentKinds,
  CashFlowItem,
  CashFlowTotals,
  CashFlowTypes,
} from '../types/cashFlow';
import { CashFlowExcelReport } from '../types/cashFlowExpenseSalary';

const cashFlowSchemas = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getCashFlow: builder.query<CashFlowItem, void>({
      query: () => ({
        url: '/v1/CashFlow',
      }),
    }),
    getCashFlowDetail: builder.query<CashFlowItem, PayloadRequest>({
      query: (data) => ({
        url: `/v1/CashFlow/${data.id}`,
      }),
    }),
    getCashFlowTypes: builder.query<CashFlowTypes[], void>({
      query: () => ({
        url: '/v1/CashFlow/cashFlowTypes',
      }),
    }),
    getCashFlowDocumentKinds: builder.query<CashFlowDocumentKinds[], void>({
      query: () => ({
        url: '/v1/CashFlow/cashFlowDocumentKinds',
      }),
    }),
    getCashFlowAccounts: builder.query<CashFlowAccounts[], void>({
      query: () => ({
        url: '/v1/CashFlow/cashFlowAccounts',
      }),
    }),
    getCashFlowTotal: builder.query<CashFlowTotals[], void>({
      query: () => ({
        url: '/v1/CashFlow/totals',
      }),
    }),
    getCashFlowHistory: builder.query<CashFlowTotals[], PayloadRequest>({
      query: ({ id: cashFlowId }) => ({
        url: `/v1/CashFlow/${cashFlowId}/history`,
      }),
    }),
    deleteCashFlowItem: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/CashFlow/${data.id}`,
        method: 'DELETE',
      }),
    }),
    cashFlowExcelReport: builder.query<void, CashFlowExcelReport>({
      query: (params) => ({
        url: '/v1/CashFlow/excelReport',
        method: 'GET',
        params,
        responseHandler: async (response) => {
          saveAs(new Blob([await response.blob()], { type: 'application/octet-stream' }), 'report.xlsx');
        },
        cache: 'no-cache',
      }),
    }),
  }),
});

export const {
  useGetCashFlowAccountsQuery,
  useGetCashFlowDocumentKindsQuery,
  useLazyGetCashFlowDocumentKindsQuery,
  useGetCashFlowTypesQuery,
  useGetCashFlowQuery,
  useGetCashFlowDetailQuery,
  useLazyGetCashFlowDetailQuery,
  useGetCashFlowTotalQuery,
  useDeleteCashFlowItemMutation,
  useLazyCashFlowExcelReportQuery,
  useLazyGetCashFlowHistoryQuery,
  useGetCashFlowHistoryQuery,
} = cashFlowSchemas;
